export default [
  {
    name: 'wholesaler/find',
    path: '/wholesaler/find',
    component() {
      return import('@/pages/wholesaler/Find.vue')
    },
  },
  {
    name: 'wholesaler/form',
    path: '/wholesaler/form',
    component() {
      return import('@/pages/wholesaler/Form.vue')
    },
  },
]
